import { createContext, useContext } from "react"
import { CompositionType } from "./constants"

export interface CompositionTypeConfig {
  type: CompositionType
  basePath: string
  listTitle: string
  itemLabel: string
  hideConsumerTypeChoice: boolean
}

export const WASTE_ORIGIN_CONFIG: CompositionTypeConfig = {
  type: CompositionType.WASTE_ORIGIN,
  basePath: "/waste-origin",
  listTitle: "Waste origin",
  itemLabel: "Waste name",
  hideConsumerTypeChoice: false,
}

export const SORTING_OUTPUT_CONFIG: CompositionTypeConfig = {
  type: CompositionType.SORTING_OUTPUT,
  basePath: "/sorting-output",
  listTitle: "Sorting output",
  itemLabel: "Sorting output name",
  hideConsumerTypeChoice: false,
}

const CompositionTypeContext = createContext<CompositionTypeConfig>(
  WASTE_ORIGIN_CONFIG,
)

export const useCompositionTypeConfig = () => useContext(CompositionTypeContext)

export default CompositionTypeContext
